/**
 * The pen and the signature of the signing pictures. The pen is drawn after the icon in DocuSign's own
 * email (a pencil leaning right over the line it writes on). Path data only, so the pictures share one
 * drawing.
 */

/** The icon in a 24-unit box: the pencil's outline and the writing line under it. */
export const PEN_ICON = {
  pencil: 'M15.4 4.9l3.7 3.7L9.3 18.4l-4.6.9.9-4.6z',
  line: 'M4.5 21.5h15',
} as const;

/**
 * The pen that writes the signature, with its tip at (0, 0) so it can be placed on any point of a path:
 * the barrel up and to the right, the cap's band across it, and the tip filled.
 */
export const WRITING_PEN = {
  barrel: 'M0 0l3.6-10 16-16 6.4 6.4-16 16z',
  band: 'M15.6-22l6.4 6.4',
  tip: 'M0 0l3.6-10 6.4 6.4z',
} as const;

/**
 * The signature the pictures show, written left to right on a line from (100, 106): a looped capital,
 * then the flowing rest. Step 3's picture writes it; the Secured picture shows it signed.
 */
export const SIGNATURE =
  'M100 106c4-14 12-22 16-18s-6 20-12 23c-5 2 0-7 8-9 6-2 8 4 12 4s6-8 10-8 2 8 6 8c5 0 6-10 11-10s2 10 7 10 8-12 14-12c4 0 2 7-2 8 8 0 11-4 18-10';
